var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_c('translate',[_vm._v("Beschrijving")])],1),_c('th',[_c('translate',[_vm._v("Waarde")])],1),_c('th',[_c('translate',[_vm._v("Verschil")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }